module.exports = __webpack_public_path__ + "img/20250228.5a8714d1.png";